import React, { forwardRef, useState, useRef } from "react";
import DatePicker from "react-datepicker";
import { FiCalendar, FiChevronDown } from "react-icons/fi";

interface PropsI {
    id?: string;
    className?: string;
    onChange: (date: Date)=>void
    placeholder?: string;
    initialDate?: Date;
    autoFocus?:boolean;
}

const BaseDatePicker = ({ autoFocus, id, className, onChange, placeholder, initialDate, }: PropsI) => {
    const [selectedDate, setSelectedDate] = useState<Date|null>(initialDate? initialDate : null)

    const datePickerRef = useRef(null);

    const handleAutoFocus = () => {
        if(datePickerRef.current){
            // @ts-ignore
            datePickerRef.current.focus()
        }
    };

    if(autoFocus) handleAutoFocus()

    const changeDate = (date:Date) => {
        onChange(date)
        setSelectedDate(date)
    }

    // @ts-ignore
    const CustomInputRef = forwardRef(({ value, onClick }, ref) => (
        <div className={`form__input--group ${className}`} onClick={onClick}>
            <div className="prepend__input">
                <FiCalendar className="text-2xl" />
            </div>
            <input id={id} placeholder={placeholder ? placeholder : 'Select date'} value={value} className="form__input prepend append" readOnly />
            <div className="append__input">
                <FiChevronDown className="text-2xl" />
            </div>
        </div>
    ));
    return (
        <DatePicker
            ref={datePickerRef}
            selected={selectedDate}
            onChange={(date: Date) => changeDate(date)}
            showMonthDropdown
            showYearDropdown
            customInput={<CustomInputRef />}
        />)
}
export default BaseDatePicker;